import { render, staticRenderFns } from "./user-roles-user-card.vue?vue&type=template&id=5eef0b63&"
import script from "./user-roles-user-card.vue?vue&type=script&lang=js&"
export * from "./user-roles-user-card.vue?vue&type=script&lang=js&"
import style0 from "./user-roles-user-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports